export default class Page {
    constructor(titles, contents) {
        this.titles = titles;
        this.contents = contents;
    }

    isValid() {
        var result = true;

        for (const [key, value] of Object.entries(this.titles)) { if(!value) { result = false; break; }; }
        for (const [key, value] of Object.entries(this.contents)) { if(!value) { result = false; break; }; }

        return result;
    }
}